/**
 * Minicart Subscription Handler
 * Hides "Buy More Save More" buttons when subscription products are in the cart
 */

(function() {
  'use strict';

  // Configuration
  const SUBSCRIPTION_IDENTIFIER = 'Subscription';
  const MINICART_SELECTOR = '#minicart';
  // Target the custom element itself, not the buttons inside its shadow DOM
  const BUY_MORE_ELEMENT_SELECTOR = 'buy-more-save-more';

  /**
   * Check if cart contains any subscription products
   * @returns {boolean}
   */
  function hasSubscriptionInCart() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const hasSubscription = cart.items.some(item => {
          // Method 1: Check variant_title
          if (item.variant_title && item.variant_title.includes(SUBSCRIPTION_IDENTIFIER)) {
            console.log('Subscription found in variant_title:', item.variant_title);
            return true;
          }
          
          // Method 2: Check product_title
          if (item.product_title && item.product_title.includes(SUBSCRIPTION_IDENTIFIER)) {
            console.log('Subscription found in product_title:', item.product_title);
            return true;
          }
          
          // Method 3: Check properties object (this is where Shopify stores subscription data)
          if (item.properties) {
            // Check if any property value contains "Subscription"
            const propertyValues = Object.values(item.properties);
            for (const value of propertyValues) {
              const stringValue = String(value);
              if (stringValue.includes(SUBSCRIPTION_IDENTIFIER)) {
                console.log('Subscription found in properties:', stringValue);
                return true;
              }
            }
          }
          
          // Method 4: Check selling_plan_allocation (Shopify native subscriptions)
          if (item.selling_plan_allocation) {
            console.log('Subscription found via selling_plan_allocation');
            return true;
          }
          
          return false;
        });
        
        console.log('Cart subscription check complete. Has subscription:', hasSubscription);
        return hasSubscription;
      })
      .catch(error => {
        console.error('Error checking cart for subscriptions:', error);
        return false;
      });
  }

  /**
   * Toggle visibility of Buy More Save More element
   * @param {boolean} hide - Whether to hide the element
   */
  function toggleBuyMoreButtons(hide) {
    // Function to find and toggle the custom element
    const findAndToggleElement = () => {
      // Find all buy-more-save-more custom elements
      const buyMoreElements = document.querySelectorAll(BUY_MORE_ELEMENT_SELECTOR);
      
      console.log(`Found ${buyMoreElements.length} <${BUY_MORE_ELEMENT_SELECTOR}> elements`);

      if (buyMoreElements.length === 0) {
        console.log(`No <${BUY_MORE_ELEMENT_SELECTOR}> elements found in document`);
        return;
      }

      buyMoreElements.forEach((element, index) => {
        if (hide) {
          element.style.display = 'none';
          element.setAttribute('data-hidden-by-subscription', 'true');
          console.log(`Hid <${BUY_MORE_ELEMENT_SELECTOR}> element #${index + 1}`);
        } else {
          element.style.display = '';
          element.removeAttribute('data-hidden-by-subscription');
          console.log(`Showed <${BUY_MORE_ELEMENT_SELECTOR}> element #${index + 1}`);
        }
      });

      console.log(`✓ Buy More Save More ${hide ? 'HIDDEN' : 'SHOWN'} - Toggled ${buyMoreElements.length} elements - Subscription in cart: ${hide}`);
    };

    // Try immediately
    findAndToggleElement();
    
    // Also try after delays in case elements load late
    setTimeout(findAndToggleElement, 300);
    setTimeout(findAndToggleElement, 600);
  }

  /**
   * Main function to check cart and update button visibility
   */
  async function updateButtonVisibility() {
    const hasSubscription = await hasSubscriptionInCart();
    toggleBuyMoreButtons(hasSubscription);
  }

  /**
   * Initialize the handler
   */
  function init() {
    // Run on page load
    updateButtonVisibility();

    // Watch for minicart opening
    const minicartObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const minicart = mutation.target;
          if (minicart.classList.contains('minicart__container--open') || 
              minicart.classList.contains('is-open')) {
            updateButtonVisibility();
          }
        }
      });
    });

    // Observe minicart container
    const observeMinicart = () => {
      const minicartContainer = document.querySelector('.minicart__container');
      if (minicartContainer) {
        minicartObserver.observe(minicartContainer, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    };

    // Wait for minicart to be in DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeMinicart);
    } else {
      observeMinicart();
    }

    // Listen for cart updates
    document.addEventListener('cart:updated', updateButtonVisibility);
    document.addEventListener('cart:refresh', updateButtonVisibility);
    
    // Also listen for custom events that might be fired by your theme
    document.addEventListener('minicart:opened', updateButtonVisibility);
    document.addEventListener('minicart:updated', updateButtonVisibility);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();